<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<h2 class="titlePageTitle">The Dream of the Ridiculous Man</h2>
<p class="titlePageSubtitle">Short Story</p>
<h2 class="titlePageAuthor">Fyodor Dostoyevsky</h2>
<p class="colophon"><img alt="image" src="Images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dreamoftheridiculousmanthe_tp01.vue?b6226bf4